// import React from 'react';
//
// const PartA1 = ({data, pageNumber, studentImage}) => {
//     const na = <span className="text-gray-400">-</span>;
//
//     const renderClassCheckboxes = (currentClassValue, options) => {
//         return options.map(opt => (
//             <label key={opt.id} className="flex items-center space-x-1 mr-4">
//                 <input type="checkbox" className="custom-checkbox" readOnly
//                        checked={currentClassValue === opt.id || currentClassValue === opt.label}/>
//                 <span className="text-xs text-gray-800">{opt.label}</span>
//             </label>
//         ));
//     };
//
//     const classOptions = [
//         {id: 'BV1', label: 'BV1'}, {id: 'BV2', label: 'BV2'}, {id: 'BV3', label: 'BV3'},
//         {id: 'Grade 1', label: 'Grade 1'}, {id: 'Grade 2', label: 'Grade 2'},
//     ];
//
//     return (
//         <div className="report-page relative font-[poppins] bg-white" style={{
//             width: '210mm',
//             height: '297mm',
//             padding: '15mm 20mm',
//             margin: '0 auto',
//             fontSize: '10pt',
//             lineHeight: '1.4',
//             color: '#333333',
//             boxSizing: 'border-box',
//             overflow: 'hidden',
//             position: 'relative',
//             breakInside: 'avoid',
//             pageBreakInside: 'avoid',
//         }}>
//
//             {/*/!* Orange corner decorations *!/*/}
//             {/*<div className="absolute top-0 right-0 w-20 h-20 bg-orange-400"*/}
//             {/*     style={{clipPath: 'polygon(100% 0, 0 0, 100% 100%)'}}/>*/}
//             {/*<div className="absolute bottom-0 left-0 w-20 h-20 bg-orange-200"*/}
//             {/*     style={{clipPath: 'polygon(0 100%, 0 0, 100% 100%)'}}/>*/}
//             {/*<div className="absolute bottom-0 right-0 w-20 h-20 bg-orange-300"*/}
//             {/*     style={{clipPath: 'polygon(100% 0, 0 100%, 100% 100%)'}}/>*/}
//
//             {/* Title */}
//             <h2 className="text-center font-bold text-lg text-orange-600 mb-4 mt-1 relative z-10">PART-A (1)</h2>
//
//             {/* School Info Header Block */}
//             <div className="mb-3 relative z-10">
//                 <div className="flex justify-between items-start mb-2">
//                     <div className="w-3/5">
//                         <div className="font-bold mb-0.5 text-xs">Name and Address of the School:</div>
//                         <div
//                             className="border-b border-gray-600 min-h-[1.3em] mb-0.5 text-xs">{data?.school_name || ''}</div>
//                         <div className="border-b border-gray-600 min-h-[1.3em] text-xs"></div>
//                     </div>
//                     <div className="w-2/5 pl-2">
//                         <div className="font-bold mb-0.5 text-right text-xs">Pin Code:</div>
//                         <div className="flex justify-end">
//                             {[...Array(6)].map((_, i) => (
//                                 <div key={i}
//                                      className="w-5 h-5 border border-gray-600 mx-0.5 flex items-center justify-center text-xs font-medium">
//                                     {data?.pin_code && data.pin_code[i] ? data.pin_code[i] : ''}
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 </div>
//
//                 {/* Village, BRC, CRC Row */}
//                 <div className="mb-2">
//                     <div className="flex items-center text-xs">
//                         <span className="font-bold mr-2">Village</span>
//                         <span
//                             className="border-b border-gray-600 w-32 mr-4 min-h-[1.3em] pb-0.5">{data?.village || ''}</span>
//                         <span className="font-bold mr-2">BRC</span>
//                         <span
//                             className="border-b border-gray-600 w-32 mr-4 min-h-[1.3em] pb-0.5">{data?.brc || ''}</span>
//                         <span className="font-bold mr-2">CRC</span>
//                         <span className="border-b border-gray-600 flex-1 min-h-[1.3em] pb-0.5">{data?.crc || ''}</span>
//                     </div>
//                 </div>
//
//                 {/* State and Pin Code Row */}
//                 <div className="mb-2">
//                     <div className="flex items-center text-xs">
//                         <span className="font-bold mr-2">State</span>
//                         <span
//                             className="border-b border-gray-600 flex-1 mr-4 min-h-[1.3em] pb-0.5">{data?.state || ''}</span>
//                     </div>
//                 </div>
//
//                 <div className="flex justify-between items-center mb-2">
//                     <div>
//                         <div className="font-bold mb-0.5 text-xs">UDISE Code:</div>
//                         <div className="flex">
//                             {[...Array(11)].map((_, i) => (
//                                 <div key={i}
//                                      className="w-5 h-5 border border-gray-600 mr-0.5 flex items-center justify-center text-xs font-medium">
//                                     {data?.udise_code && data.udise_code[i] ? data.udise_code[i] : ''}
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                     <div>
//                         <div className="font-bold mb-0.5 text-right text-xs">Teacher Code:</div>
//                         <div className="flex justify-end">
//                             {[...Array(3)].map((_, i) => (
//                                 <div key={i}
//                                      className="w-5 h-5 border border-gray-600 mx-0.5 flex items-center justify-center text-xs font-medium">
//                                     {data?.teacher_code && data.teacher_code[i] ? data.teacher_code[i] : ''}
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 </div>
//
//                 <div className="mb-2">
//                     <div className="font-bold text-xs mb-0.5">APAAR ID:</div>
//                     <div
//                         className="border-b-2 border-gray-800 min-h-[1.3em] text-xs font-medium">{data?.apaar_id || ''}</div>
//                 </div>
//             </div>
//
//             {/* GENERAL INFORMATION Header */}
//             <div className="bg-orange-600 text-white py-2 px-4 text-center font-bold text-base mb-1"
//                  style={{marginLeft: '-20mm', marginRight: '-20mm'}}>
//                 GENERAL INFORMATION
//             </div>
//             <div className="text-[8pt] text-gray-600 mb-2 italic text-center">
//                 (To be filled by the teacher in consultation with caregiver/parent)
//             </div>
//
//             {/* Student Information with Photograph */}
//             <div className="flex justify-between items-start mb-2">
//                 <div className="w-[calc(100%-100px)] pr-2">
//                     <div className="mb-1.5">
//                         <div className="flex items-center">
//                             <div className="w-28 font-bold text-xs">Student Name:</div>
//                             <div
//                                 className="flex-1 border-b border-gray-600 min-h-[1.3em] text-xs font-medium pl-1 pb-0.5">{data?.student_name || ''}</div>
//                         </div>
//                     </div>
//
//                     <div className="mb-1.5 flex">
//                         <div className="w-20 font-bold text-xs">Roll No.</div>
//                         <div
//                             className="w-24 border-b border-gray-600 min-h-[1.3em] text-xs font-medium mr-3 pl-1 pb-0.5">{data?.roll_no || ''}</div>
//                         <div className="w-28 font-bold text-xs">Registration No.:</div>
//                         <div
//                             className="flex-1 border-b border-gray-600 min-h-[1.3em] text-xs font-medium pl-1 pb-0.5">{data?.registration_no || ''}</div>
//                     </div>
//
//                     <div className="mb-1.5">
//                         <div className="flex items-center">
//                             <div className="font-bold mr-3 text-xs">Class:</div>
//                             <div className="flex flex-wrap">
//                                 {renderClassCheckboxes(data?.class_grade, classOptions)}
//                             </div>
//                         </div>
//                     </div>
//
//                     <div className="mb-1.5 flex">
//                         <div className="w-20 font-bold text-xs">Section:</div>
//                         <div
//                             className="w-24 border-b border-gray-600 min-h-[1.3em] text-xs font-medium mr-3 pl-1 pb-0.5">{data?.section || ''}</div>
//                         <div className="w-28 font-bold text-xs">Date of Birth:</div>
//                         <div
//                             className="flex-1 border-b border-gray-600 min-h-[1.3em] text-xs font-medium pl-1 pb-0.5">{data?.date_of_birth || ''}</div>
//                     </div>
//
//                     <div className="mb-1.5">
//                         <div className="flex items-center">
//                             <div className="w-20 font-bold text-xs">Address:</div>
//                             <div
//                                 className="flex-1 border-b border-gray-600 min-h-[1.3em] text-xs font-medium pl-1 pb-0.5">{data?.address || ''}</div>
//                         </div>
//                     </div>
//
//                     <div className="mb-1.5">
//                         <div className="flex items-center">
//                             <div className="flex-1 border-b border-gray-600 min-h-[1.3em]"></div>
//                             <div className="w-20 font-bold text-xs text-right ml-3">Phone:</div>
//                         </div>
//                         <div
//                             className="border-b border-gray-600 min-h-[1.3em] text-xs font-medium pl-1 pb-0.5">{data?.phone || ''}</div>
//                     </div>
//                 </div>
//                 <div
//                     className="w-[100px] h-[120px] border-2 border-gray-600 flex flex-col items-center justify-center bg-gray-50 text-center overflow-hidden">
//                     {studentImage ? (
//                         <img
//                             src={studentImage}
//                             alt="Student"
//                             className="w-full h-full object-cover"
//                             crossOrigin="anonymous"
//                             style={{maxWidth: '100%', maxHeight: '100%'}}
//                         />
//                     ) : (
//                         <div className="text-sm font-bold">Photograph</div>
//                     )}
//                 </div>
//             </div>
//
//             {/* Guardian Information */}
//             <div className="space-y-1.5 mb-2">
//                 <div className="flex items-center">
//                     <div className="w-44 font-bold text-xs">Mother/Guardian Name:</div>
//                     <div
//                         className="flex-1 border-b border-gray-600 min-h-[1.3em] text-xs font-medium pl-1 pb-0.5">{data?.mother_name || ''}</div>
//                 </div>
//
//                 <div className="flex items-center">
//                     <div className="w-44 font-bold text-xs">Mother/Guardian Education:</div>
//                     <div
//                         className="w-28 border-b border-gray-600 min-h-[1.3em] text-xs font-medium mr-3 pl-1 pb-0.5">{data?.mother_education || ''}</div>
//                     <div className="w-44 font-bold text-xs">Mother/Guardian Occupation:</div>
//                     <div
//                         className="flex-1 border-b border-gray-600 min-h-[1.3em] text-xs font-medium pl-1 pb-0.5">{data?.mother_occupation || ''}</div>
//                 </div>
//
//                 <div className="flex items-center">
//                     <div className="w-44 font-bold text-xs">Father/Guardian Name:</div>
//                     <div
//                         className="flex-1 border-b border-gray-600 min-h-[1.3em] text-xs font-medium pl-1 pb-0.5">{data?.father_name || ''}</div>
//                 </div>
//
//                 <div className="flex items-center">
//                     <div className="w-44 font-bold text-xs">Father/Guardian Education:</div>
//                     <div
//                         className="w-28 border-b border-gray-600 min-h-[1.3em] text-xs font-medium mr-3 pl-1 pb-0.5">{data?.father_education || ''}</div>
//                     <div className="w-44 font-bold text-xs">Father/Guardian Occupation:</div>
//                     <div
//                         className="flex-1 border-b border-gray-600 min-h-[1.3em] text-xs font-medium pl-1 pb-0.5">{data?.father_occupation || ''}</div>
//                 </div>
//             </div>
//
//             {/* Other Details */}
//             <div className="grid grid-cols-2 gap-x-6 gap-y-1.5 mb-2">
//                 <div className="flex items-center">
//                     <div className="w-32 font-bold text-xs">Number of siblings:</div>
//                     <div
//                         className="flex-1 border-b border-gray-600 min-h-[1.3em] text-xs font-medium pl-1 pb-0.5">{data?.number_of_siblings || ''}</div>
//                 </div>
//                 <div className="flex items-center">
//                     <div className="w-24 font-bold text-xs">Siblings' age:</div>
//                     <div
//                         className="flex-1 border-b border-gray-600 min-h-[1.3em] text-xs font-medium pl-1 pb-0.5">{data?.siblings_age?.join(', ') || ''}</div>
//                 </div>
//                 <div className="flex items-center">
//                     <div className="w-32 font-bold text-xs">Mother Tongue:</div>
//                     <div
//                         className="flex-1 border-b border-gray-600 min-h-[1.3em] text-xs font-medium pl-1 pb-0.5">{data?.mother_tongue || ''}</div>
//                 </div>
//                 <div className="flex items-center">
//                     <div className="w-24 font-bold text-xs">Medium of Instruction:</div>
//                     <div
//                         className="flex-1 border-b border-gray-600 min-h-[1.3em] text-xs font-medium pl-1 pb-0.5">{data?.medium_of_instruction || ''}</div>
//                 </div>
//                 <div className="flex items-center">
//                     <div className="w-32 font-bold text-xs">Rural/Urban:</div>
//                     <div
//                         className="flex-1 border-b border-gray-600 min-h-[1.3em] text-xs font-medium pl-1 pb-0.5">{data?.rural_or_urban || ''}</div>
//                 </div>
//                 <div className="flex items-center">
//                     <div className="w-32 font-bold text-xs">Times fallen ill:</div>
//                     <div
//                         className="flex-1 border-b border-gray-600 min-h-[1.3em] text-xs font-medium pl-1 pb-0.5">{data?.times_fallen_ill || ''}</div>
//                 </div>
//             </div>
//
//             {/* Attendance Table */}
//             <div className="mb-2">
//                 <div className="bg-orange-500 text-white py-0.5 px-2 text-xs font-bold inline-block mb-1">
//                     ATTENDANCE
//                 </div>
//                 <table className="w-full border-collapse">
//                     <thead>
//                     <tr>
//                         {['MONTHS', 'APR', 'MAY', 'JUNE', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC', 'JAN', 'FEB', 'MAR'].map(m => (
//                             <th key={m}
//                                 className="border border-gray-800 bg-orange-200 text-orange-900 py-0.5 px-1 text-center text-[7pt] font-bold">
//                                 {m}
//                             </th>
//                         ))}
//                     </tr>
//                     </thead>
//                     <tbody>
//                     <tr>
//                         <td className="border border-gray-800 bg-orange-100 py-0.5 px-1 text-[7pt] font-bold text-orange-900">No.
//                             of Working Days
//                         </td>
//                         {['APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC', 'JAN', 'FEB', 'MAR'].map((month) => (
//                             <td key={month} className="border border-gray-800 py-0.5 px-1 text-center h-4 text-[7pt]">
//                                 {data?.attendance_working_days?.[month] || ''}
//                             </td>
//                         ))}
//                     </tr>
//                     <tr>
//                         <td className="border border-gray-800 bg-orange-100 py-0.5 px-1 text-[7pt] font-bold text-orange-900">No.
//                             of Days Attended
//                         </td>
//                         {['APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC', 'JAN', 'FEB', 'MAR'].map((month) => (
//                             <td key={month} className="border border-gray-800 py-0.5 px-1 text-center h-4 text-[7pt]">
//                                 {data?.attendance_days_attended?.[month] || ''}
//                             </td>
//                         ))}
//                     </tr>
//                     <tr>
//                         <td className="border border-gray-800 bg-orange-100 py-0.5 px-1 text-[7pt] font-bold text-orange-900">%
//                             of Attendance
//                         </td>
//                         {['APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC', 'JAN', 'FEB', 'MAR'].map((month) => {
//                             const working = data?.attendance_working_days?.[month] || 0;
//                             const attended = data?.attendance_days_attended?.[month] || 0;
//                             const percentage = working > 0 ? Math.round((attended / working) * 100) : '';
//                             return (
//                                 <td key={month}
//                                     className="border border-gray-800 py-0.5 px-1 text-center h-4 text-[7pt]">
//                                     {percentage && `${percentage}%`}
//                                 </td>
//                             );
//                         })}
//                     </tr>
//                     <tr>
//                         <td colSpan="13" className="border border-gray-800 py-1 px-1 text-[7pt] text-center">
//                             <span className="font-bold mr-1">If attendance is low then reasons there of:</span>
//                             <span className="inline-block border-b border-gray-600 min-h-[1em] w-3/5 pl-1 pb-0.5">
//                                 {data?.attendance_low_reason || ''}
//                             </span>
//                         </td>
//                     </tr>
//                     </tbody>
//                 </table>
//             </div>
//
//             {/* Interest Section */}
//             <div className="mb-1">
//                 <div className="bg-orange-500 text-white py-0.5 px-2 text-xs font-bold inline-block">
//                     INTEREST <span className="font-normal italic text-[7pt]">(I (the student) am interested in)*:</span>
//                 </div>
//             </div>
//             <p className="text-[7pt] text-gray-600 mb-1 italic">* May choose more than one option</p>
//
//             <div className="border border-orange-300 p-2 bg-orange-50 mb-2">
//                 <div className="grid grid-cols-2 gap-x-2 gap-y-1 text-xs mb-2">
//                     <div className="flex items-center">
//                         <input
//                             type="checkbox"
//                             id="interest-reading"
//                             className="mr-2 h-3 w-3"
//                             readOnly
//                             checked={data?.interests?.includes('reading') || false}
//                         />
//                         <label htmlFor="interest-reading" className="cursor-default">Reading</label>
//                     </div>
//                     <div className="flex items-center">
//                         <input
//                             type="checkbox"
//                             id="interest-dancing"
//                             className="mr-1 h-3 w-3"
//                             readOnly
//                             checked={data?.interests?.includes('dancing_singing_instrument') || false}
//                         />
//                         <label htmlFor="interest-dancing" className="cursor-default text-[8pt]">Dancing or Singing or
//                             Playing a musical instrument</label>
//                     </div>
//                     <div className="flex items-center">
//                         <input
//                             type="checkbox"
//                             id="interest-sport"
//                             className="mr-1 h-3 w-3"
//                             readOnly
//                             checked={data?.interests?.includes('sport_games') || false}
//                         />
//                         <label htmlFor="interest-sport" className="cursor-default">Sport or Games</label>
//                     </div>
//                     <div className="flex items-center">
//                         <input
//                             type="checkbox"
//                             id="interest-writing"
//                             className="mr-1 h-3 w-3"
//                             readOnly
//                             checked={data?.interests?.includes('creative_writing') || false}
//                         />
//                         <label htmlFor="interest-writing" className="cursor-default">Creative writing</label>
//                     </div>
//                     <div className="flex items-center">
//                         <input
//                             type="checkbox"
//                             id="interest-gardening"
//                             className="mr-1 h-3 w-3"
//                             readOnly
//                             checked={data?.interests?.includes('gardening') || false}
//                         />
//                         <label htmlFor="interest-gardening" className="cursor-default">Gardening</label>
//                     </div>
//                     <div className="flex items-center">
//                         <input
//                             type="checkbox"
//                             id="interest-yoga"
//                             className="mr-1 h-3 w-3"
//                             readOnly
//                             checked={data?.interests?.includes('yoga') || false}
//                         />
//                         <label htmlFor="interest-yoga" className="cursor-default">Yoga</label>
//                     </div>
//                     <div className="flex items-center">
//                         <input
//                             type="checkbox"
//                             id="interest-art"
//                             className="mr-1 h-3 w-3"
//                             readOnly
//                             checked={data?.interests?.includes('art') || false}
//                         />
//                         <label htmlFor="interest-art" className="cursor-default">Art</label>
//                     </div>
//                     <div className="flex items-center">
//                         <input
//                             type="checkbox"
//                             id="interest-craft"
//                             className="mr-1 h-3 w-3"
//                             readOnly
//                             checked={data?.interests?.includes('craft') || false}
//                         />
//                         <label htmlFor="interest-craft" className="cursor-default">Craft</label>
//                     </div>
//                     <div className="flex items-center col-span-2 justify-center">
//                         <input
//                             type="checkbox"
//                             id="interest-cooking"
//                             className="mr-1 h-3 w-3"
//                             readOnly
//                             checked={data?.interests?.includes('cooking') || false}
//                         />
//                         <label htmlFor="interest-cooking" className="cursor-default">Cooking</label>
//                     </div>
//                     <div className="flex items-center col-span-2">
//                         <input
//                             type="checkbox"
//                             id="interest-chores"
//                             className="mr-1 h-3 w-3"
//                             readOnly
//                             checked={data?.interests?.includes('chores') || false}
//                         />
//                         <label htmlFor="interest-chores" className="cursor-default text-[8pt]">Regular chores at home
//                             with significant others (father, mother, guardian, sibling, etc.)</label>
//                     </div>
//                     <div className="flex items-center col-span-2">
//                         <input
//                             type="checkbox"
//                             id="interest-other"
//                             className="mr-1 h-3 w-3"
//                             readOnly
//                             checked={!!data?.other_interest_specified}
//                         />
//                         <label htmlFor="interest-other" className="mr-1 cursor-default">Other</label>
//                         <span className="text-[7pt] italic mr-1">Please specify</span>
//                         <span className="border-b border-gray-600 flex-1 min-h-[1em] pl-1 pb-0.5 text-[8pt]">
//                             {data?.other_interest_detail || ''}
//                         </span>
//                     </div>
//                 </div>
//
//                 {/* Dotted lines for additional notes */}
//                 <div className="space-y-1.5">
//                     <div className="border-b border-dotted border-gray-400 h-3"></div>
//                     <div className="border-b border-dotted border-gray-400 h-3"></div>
//                     <div className="border-b border-dotted border-gray-400 h-3"></div>
//                 </div>
//             </div>
//
//             {/* Page number */}
//             <div className="absolute bottom-4 right-0 left-0 flex justify-center">
//                 <div className="border-t border-gray-300 w-1/3 pt-1 text-center">{pageNumber || '3'}</div>
//             </div>
//         </div>
//     );
// };
//
// export default PartA1;

import React from 'react';

const PartA1 = ({ data, studentImage }) => {
    const na = <span className="text-gray-400">-</span>;

    const renderClassCheckboxes = (currentClassValue, options) => {
        return options.map(opt => (
            <label key={opt.id} className="flex items-center space-x-1 mr-4">
                <input type="checkbox" className="custom-checkbox" readOnly
                    checked={currentClassValue === opt.id || currentClassValue === opt.label} />
                <span className="text-xs text-gray-800">{opt.label}</span>
            </label>
        ));
    };

    const classOptions = [
        { id: 'BV1', label: 'BV1' }, { id: 'BV2', label: 'BV2' }, { id: 'BV3', label: 'BV3' },
        { id: 'Grade 1', label: 'Grade 1' }, { id: 'Grade 2', label: 'Grade 2' },
    ];

    const months = ['APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC', 'JAN', 'FEB', 'MAR'];

    const workingDays = data?.attendance_working_days || {};
    const attendedDays = data?.attendance_days_attended || {};
    const percentAttendance = months.map(m => {
        const wd = workingDays[m] || 0;
        const ad = attendedDays[m] || 0;
        return wd > 0 ? ((ad / wd) * 100).toFixed(0) : '-';
    });


    return (
        <div className="report-page relative font-[poppins] bg-white" style={{
            width: '210mm',
            height: '297mm',
            padding: '15mm 20mm',
            margin: '0 auto',
            fontSize: '10pt',
            lineHeight: '1.6', // Increased line-height for more vertical space
            color: '#333333',
            boxSizing: 'border-box',
            overflow: 'hidden',
            position: 'relative',
            breakInside: 'avoid',
            pageBreakInside: 'avoid',
            '@media print': {
                margin: 0,
                padding: '15mm 20mm',
                boxShadow: 'none',
                width: '210mm',
                height: '297mm'
            }
        }}>
            {/* Orange corner triangles */}
            <div className="absolute top-0 right-0 w-0 h-0"
                style={{
                    borderTop: '80px solid #f1905b',
                    borderLeft: '80px solid transparent'
                }}>
            </div>
            <div className="absolute bottom-0 left-0 w-0 h-0"
                style={{
                    borderBottom: '80px solid #F97316',
                    borderRight: '80px solid transparent'
                }}>
            </div>

            {/* Title */}
            <h2 className="text-center font-bold text-lg text-orange-600 mb-4 mt-1">PART-A (1)</h2>

            {/* School Info Header Block */}
            {/* Further increased bottom margin for more space */}
            <div className="mb-6 text-xs w-full">
                <div className="flex items-center mb-3">
                    <div className="flex-1 flex items-center">
                        <div className="font-bold whitespace-nowrap">Name and Address of the School:</div>
                        <div
                            className="flex-1 border-b border-dotted border-black ml-2 h-[1.2em] text-xs min-h-[1.3em] font-medium">{data?.school_name || ''}</div>
                    </div>
                </div>

                <div className="flex items-center mb-3">
                    <div className="flex-1 border-b border-dotted border-black mr-3 h-[1.2em]" />
                    <div className="flex items-center min-w-[140px] ml-6">
                        <div className="font-bold mr-1 whitespace-nowrap">Pin Code:</div>
                        <div className="flex">
                            {[...Array(6)].map((_, i) => (
                                <div key={i}
                                    className="w-5 h-5 border border-black mx-0.5 flex items-center justify-center font-medium">
                                    {data?.pin_code && data.pin_code[i] ? data.pin_code[i] : ''}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="flex items-center mb-3">
                    <div className="flex items-center flex-1">
                        <div className="font-bold whitespace-nowrap mr-1">UDISE Code:</div>
                        <div className="flex">
                            {[...Array(11)].map((_, i) => (
                                <div key={i}
                                    className="w-5 h-5 border border-black mr-0.5 flex items-center justify-center font-medium">
                                    {data?.udise_code && data.udise_code[i] ? data.udise_code[i] : ''}
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="flex items-center min-w-[110px] ml-4">
                        <div className="font-bold mr-1 whitespace-nowrap">Teacher Code:</div>
                        <div className="flex">
                            {[...Array(3)].map((_, i) => (
                                <div key={i}
                                    className="w-5 h-5 border border-black mx-0.5 flex items-center justify-center font-medium">
                                    {data?.teacher_code && data.teacher_code[i] ? data.teacher_code[i] : ''}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="flex items-center mb-2">
                    <div className="font-bold whitespace-nowrap mr-1">APAAR ID:</div>
                    <div className="flex-1 border-b border-dotted border-black h-[1.2em] flex items-center">
                        <span className="ml-2 font-medium">{data?.apaar_id || ''}</span>
                    </div>
                </div>
            </div>

            <div className="w-full">
                <div className="border-b-2 border-orange-400 w-full mb-1" />
                <div className="font-bold text-[13pt] text-orange-600 text-center">
                    GENERAL INFORMATION
                </div>
                <div className="text-[9pt] font-bold text-black text-center mb-4"> {/* Increased margin */}
                    (To be filled by the teacher in consultation with caregiver/parent)
                </div>
            </div>

            {/* Student Information with Photograph */}
            <div className="flex justify-between items-start mb-7"> {/* Increased margin */}
                <div className="w-[calc(100%-100px)] pr-2">
                    {/* Increased internal spacing from mb-2.5 to mb-3.5 */}
                    <div className="mb-3.5">
                        <div className="flex items-center">
                            <div className="w-28 font-bold text-xs">Student Name:</div>
                            <div
                                className="flex-1 border-b border-black min-h-[1.3em] text-xs font-medium pl-1 pb-0.5">{data?.student_name || ''}</div>
                        </div>
                    </div>

                    <div className="mb-3.5 flex">
                        <div className="w-20 font-bold text-xs">Roll No.</div>
                        <div
                            className="w-24 border-b  border-black min-h-[1.3em] text-xs font-medium mr-3 pl-1 pb-0.5">{data?.roll_no || ''}</div>
                        <div className="w-28 font-bold text-xs">Registration No.:</div>
                        <div
                            className="flex-1 border-b  border-black min-h-[1.3em] text-xs font-medium pl-1 pb-0.5">{data?.registration_no || ''}</div>
                    </div>

                    <div className="mb-3.5">
                        <div className="flex items-center">
                            <div className="font-bold mr-3 text-xs">Class:</div>
                            <div className="flex flex-wrap">
                                {renderClassCheckboxes(data?.class_grade, classOptions)}
                            </div>
                        </div>
                    </div>

                    <div className="mb-3.5 flex">
                        <div className="w-20 font-bold text-xs">Section:</div>
                        <div
                            className="w-24 border-b  border-black min-h-[1.3em] text-xs font-medium mr-3 pl-1 pb-0.5">{data?.section || ''}</div>
                        <div className="w-28 font-bold text-xs">Date of Birth:</div>
                        <div
                            className="flex-1 border-b  border-black min-h-[1.3em] text-xs font-medium pl-1 pb-0.5">{data?.date_of_birth || ''}</div>
                    </div>

                    <div className="mb-3.5">
                        <div className="flex items-center">
                            <div className="w-20 font-bold text-xs">Address:</div>
                            <div
                                className="flex-1 border-b  border-black min-h-[1.3em] text-xs font-medium pl-1 pb-0.5">{data?.address || ''}</div>
                        </div>
                    </div>
                    <div className="mb-3.5">
                        <div className="flex items-center">
                            <div className="flex-1 border-b  border-black min-h-[1.3em]"></div>
                            <div className="w-20 font-bold text-xs text-right ml-3">Phone:</div>
                            <div
                                className="flex-1 border-b  border-black min-h-[1.3em] text-xs font-medium pl-1 pb-0.5">{data?.phone || ''}</div>
                        </div>
                    </div>
                </div>
                <div
                    className="w-[100px] h-[120px] border-2 border-black flex flex-col items-center justify-center bg-gray-50 text-center overflow-hidden">
                    {studentImage ? (
                        <img
                            src={studentImage}
                            alt="Student"
                            className="w-full h-full object-cover"
                            crossOrigin="anonymous"
                        />
                    ) : (
                        <div className="text-sm font-bold">Photograph</div>
                    )}
                </div>
            </div>

            {/* Guardian Information */}
            <div className="space-y-4 mb-7"> {/* Increased space-y and margin */}
                <div className="flex items-center">
                    <div className="w-44 font-bold text-xs">Mother/Guardian Name:</div>
                    <div
                        className="flex-1 border-b  border-black min-h-[1.3em] text-xs font-medium pl-1 pb-0.5">{data?.mother_name || ''}</div>
                </div>

                <div className="flex items-center">
                    <div className="w-44 font-bold text-xs">Mother/Guardian Education:</div>
                    <div
                        className="w-40 border-b  border-black min-h-[1.3em] text-xs font-medium mr-3 pl-1 pb-0.5">{data?.mother_education || ''}</div>
                    <div className="w-44 font-bold text-xs">Mother/Guardian Occupation:</div>
                    <div
                        className="flex-1 border-b  border-black min-h-[1.3em] text-xs font-medium pl-1 pb-0.5">{data?.mother_occupation || ''}</div>
                </div>

                <div className="flex items-center">
                    <div className="w-44 font-bold text-xs">Father/Guardian Name:</div>
                    <div
                        className="flex-1 border-b  border-black min-h-[1.3em] text-xs font-medium pl-1 pb-0.5">{data?.father_name || ''}</div>
                </div>

                <div className="flex items-center">
                    <div className="w-44 font-bold text-xs">Father/Guardian Education:</div>
                    <div
                        className="w-40 border-b  border-black min-h-[1.3em] text-xs font-medium mr-3 pl-1 pb-0.5">{data?.father_education || ''}</div>
                    <div className="w-44 font-bold text-xs">Father/Guardian Occupation:</div>
                    <div
                        className="flex-1 border-b  border-black min-h-[1.3em] text-xs font-medium pl-1 pb-0.5">{data?.father_occupation || ''}</div>
                </div>
            </div>

            {/* Other Details */}
            <div className="grid grid-cols-2 gap-x-6 gap-y-4 mb-7"> {/* Increased gaps and margin */}
                <div className="flex items-center">
                    <div className="w-32 font-bold text-xs">Number of siblings:</div>
                    <div
                        className="flex-1 border-b  border-black min-h-[1.3em] text-xs font-medium pl-1 pb-0.5">{data?.number_of_siblings || ''}</div>
                </div>
                <div className="flex items-center">
                    <div className="w-24 font-bold text-xs">Siblings' age:</div>
                    <div
                        className="flex-1 border-b  border-black min-h-[1.3em] text-xs font-medium pl-1 pb-0.5">{data?.siblings_age?.join(', ') || ''}</div>
                </div>
                <div className="flex items-center">
                    <div className="w-32 font-bold text-xs">Mother Tongue:</div>
                    <div
                        className="flex-1 border-b  border-black min-h-[1.3em] text-xs font-medium pl-1 pb-0.5">{data?.mother_tongue || ''}</div>
                </div>
                <div className="flex items-center">
                    <div className="w-24 font-bold text-xs">Medium of Instruction:</div>
                    <div
                        className="flex-1 border-b  border-black min-h-[1.3em] text-xs font-medium pl-1 pb-0.5">{data?.medium_of_instruction || ''}</div>
                </div>
                <div className="flex items-center">
                    <div className="w-32 font-bold text-xs">Rural/Urban:</div>
                    <div
                        className="flex-1 border-b  border-black min-h-[1.3em] text-xs font-medium pl-1 pb-0.5">{data?.rural_or_urban || ''}</div>
                </div>
            </div>

            {/*/!* Attendance Table *!/*/}
            {/*/!* Positioned directly after profile info. Table cells are taller. *!/*/}
            {/*<div className="mt-4">*/}
            {/*    <div className="text-[#e36c09] py-0.5 text-xs font-bold inline-block mb-1">*/}
            {/*        ATTENDANCE*/}
            {/*    </div>*/}
            {/*    <table className="w-full border-collapse">*/}
            {/*        <thead>*/}
            {/*        <tr>*/}
            {/*            {['MONTHS', 'APR', 'MAY', 'JUNE', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC', 'JAN', 'FEB', 'MAR'].map(m => (*/}
            {/*                <th key={m}*/}
            {/*                    className="border border-gray-800 bg-[#e36c09] text-white py-1 px-1 text-center text-[7pt] font-bold">*/}
            {/*                    {m}*/}
            {/*                </th>*/}
            {/*            ))}*/}
            {/*        </tr>*/}
            {/*        </thead>*/}
            {/*        <tbody>*/}
            {/*        {['No. of Working Days', 'No. of Days Attended', '% of Attendance'].map((label, idx) => (*/}
            {/*            <tr key={idx}>*/}
            {/*                <td className="border border-gray-800 bg-[#fde9d9] py-1.5 px-1 text-[7pt] font-bold text-orange-900">{label}</td>*/}
            {/*                {Array(12).fill('').map((_, i) => (*/}
            {/*                    <td key={i} className="border border-gray-800 py-1.5 px-1 text-center"></td>*/}
            {/*                ))}*/}
            {/*            </tr>*/}
            {/*        ))}*/}
            {/*        <tr>*/}
            {/*            <td colSpan="13" className="border border-gray-800 py-2 px-1 text-[7pt] text-center">*/}
            {/*                <span className="font-bold mr-1">If attendance is low then reasons there of:</span>*/}
            {/*                <span*/}
            {/*                    className="inline-block border-b border-dotted border-black min-h-[1em] w-3/5 align-bottom"></span>*/}
            {/*            </td>*/}
            {/*        </tr>*/}
            {/*        </tbody>*/}
            {/*    </table>*/}
            {/*</div>*/}


            {/* Attendance Table */}
            <div className="mb-2">
                <div className=" text-[#e36c09] py-0.5 text-xs font-bold inline-block mb-1">
                    ATTENDANCE
                </div>
                <table className="w-full border-collapse">
                    <thead>
                        <tr>
                            {['MONTHS', 'APR', 'MAY', 'JUNE', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC', 'JAN', 'FEB', 'MAR'].map(m => (
                                <th key={m}
                                    className="border border-gray-800 bg-[#e36c09] text-white py-0.5 px-1 text-center text-[7pt] font-bold">
                                    {m}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {/* No. of Working Days */}
                        <tr>
                            <td className="border border-gray-800 bg-[#fde9d9] py-1.5 px-1 text-[7pt] font-bold text-orange-900">No.
                                of Working Days
                            </td>
                            {months.map(m => (
                                <td key={m}
                                    className="border border-gray-800 py-1.5 px-1 text-center">{workingDays[m] ?? ''}</td>
                            ))}
                        </tr>
                        {/* No. of Days Attended */}
                        <tr>
                            <td className="border border-gray-800 bg-[#fde9d9] py-1.5 px-1 text-[7pt] font-bold text-orange-900">No.
                                of Days Attended
                            </td>
                            {months.map(m => (
                                <td key={m}
                                    className="border border-gray-800 py-1.5 px-1 text-center">{attendedDays[m] ?? ''}</td>
                            ))}
                        </tr>
                        {/* % of Attendance */}
                        <tr>
                            <td className="border border-gray-800 bg-[#fde9d9] py-1.5 px-1 text-[7pt] font-bold text-orange-900">%
                                of Attendance
                            </td>
                            {percentAttendance.map((pa, idx) => (
                                <td key={months[idx]} className="border border-gray-800 py-1.5 px-1 text-center">{pa}</td>
                            ))}
                        </tr>
                        {/* Reason for low attendance */}
                        <tr>
                            <td colSpan="13" className="border border-gray-800 py-2 px-1 text-[7pt] text-center">
                                <span className="font-bold mr-1">If attendance is low then reasons there of:</span>
                                <span
                                    className="inline-block border-b border-dotted border-black min-h-[1em] w-3/5 align-bottom">
                                    {data?.attendance_low_reason || ''}
                                </span>
                            </td>
                        </tr>
                    </tbody>

                </table>
            </div>


            {/* This div pushes the page number to the bottom correctly */}
            <div className="flex-grow"></div>

            <div className="border-b-2 border-[#fbd3b1] w-full mb-4" />
        </div>
    );
};

export default PartA1;